module.exports = __webpack_public_path__ + "img/protection_uvmilk.5ba51078.jpg";